@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.rides
import com.narbase.letsgo.dto.core.KmmLong

import com.narbase.letsgo.router.EndPoint


object RegisterLiveActivityPushTokenEndpoint :
    EndPoint<RegisterLiveActivityPushTokenEndpoint.Request, RegisterLiveActivityPushTokenEndpoint.Response>() {

    class Request(
        val rideId: KmmLong?,
        val token: String
    )

    class Response
}
